import React, { Component } from 'react'
import { observable, toJS } from 'mobx'
import { observer } from 'mobx-react'
import { Link } from 'react-router'
import { autobind } from 'core-decorators'
import getPath from '../../../shared/utils/getPath'
import Content from './Content'

const getDefaults = () => ({
  firstname: '',
  lastname: '',
  street: '',
  zip: '',
  location: '',
  email: '',
  phone: '',
  message: '',
  dsgvoAccepted: false
})

@observer
export default class ContactPage extends Component {

  @observable message = ''

  @observable formData = getDefaults()

  @autobind
  handleChange({
    target: {
      name, value, checked, type
    }
  }) {
    const val = type === 'checkbox' ? checked : value
    this.formData[name] = val
  }

  reset() {
    this.formData = getDefaults()
    this.message = ''
  }

  @autobind
  handleSubmit(e) {
    e.preventDefault()
    const data = toJS(this.formData)
    this.reset()
    const headers = new Headers()
    headers.append('Content-Type', 'application/json')
    fetch(`${window.APP_CONFIG.API_URL}contact`, {
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify(data),
      headers
    })
      .then((res) => {
        if (!res.ok) {
          this.formData = data
          res.json().then((err) => {
            this.message = err.message
          })
        }
        else {
          this.message = 'Nachricht verschickt.'
        }
      })
      .catch((ex) => {
        this.message = ex.message
        this.formData = data
      })
  }

  /* eslint-disable max-len */
  render() {

    const complete = this.formData.firstname.trim()
      && this.formData.lastname.trim()
      && this.formData.email.trim()
      && this.formData.message.trim()
      && this.formData.dsgvoAccepted

    const successfulySent = this.message === 'Nachricht verschickt.'

    return (
      <Content>
        <div className="contact-form">
          <h1>Kontakt</h1>

          Bezirk Oberfranken | KulturServiceStelle
          <br />
          Adolf-Wächter-Straße 17 | 95447 Bayreuth
          <br />
          <a
            href="http://kss.bezirk-oberfranken.de"
            target="_blank"
            rel="noopener noreferrer"
          >
            kss.bezirk-oberfranken.de
          </a>
          <br />
          <br />
          Barbara Christoph M.A., Leiterin
          <br />
          Telefon: 0921 7846-1430


          <form
            className="form form-horizontal clearfix inner"
            onChange={this.handleChange}
            onSubmit={this.handleSubmit}
          >

            <h2>Kontaktformular</h2>

            <div className="message help-block">
              {this.message}
            </div>

            {!successfulySent
              ? (
                <div>

                  <p>Schreiben Sie der KulturServiceStelle</p>

                  <div className="form-group">
                    <label
                      className="col-xs-4"
                      htmlFor="contact-firstname"
                    >
                      Vorname:
                    </label>
                    <div className="col-xs-8">
                      <input
                        value={this.formData.firstname}
                        required
                        autoFocus
                        type="text"
                        className="form-control input-sm"
                        id="contact-firstname"
                        name="firstname"
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label
                      className="col-xs-4"
                      htmlFor="contact-lastname"
                    >
                      Nachname:
                    </label>
                    <div className="col-xs-8">
                      <input
                        value={this.formData.lastname}
                        required
                        type="text"
                        className="form-control input-sm"
                        id="contact-lastname"
                        name="lastname"
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label
                      className="col-xs-4"
                      htmlFor="contact-street"
                    >
                      Straße:
                      <small>(optional)</small>
                    </label>
                    <div className="col-xs-8">
                      <input
                        value={this.formData.street}
                        type="text"
                        className="form-control input-sm"
                        id="contact-street"
                        name="street"
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label
                      className="col-xs-4"
                      htmlFor="contact-zip"
                    >
                      PLZ / Wohnort:
                      <small>(optional)</small>
                    </label>
                    <div className="col-xs-3">
                      <input
                        value={this.formData.zip}
                        type="text"
                        className="form-control input-sm"
                        id="contact-zip"
                        name="zip"
                      />
                    </div>
                    <div className="col-xs-5">
                      <input
                        value={this.formData.location}
                        type="text"
                        className="form-control input-sm"
                        id="contact-location"
                        name="location"
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label
                      className="col-xs-4"
                      htmlFor="contact-email"
                    >
                      E-Mail:
                    </label>
                    <div className="col-xs-8">
                      <input
                        value={this.formData.email}
                        required
                        type="email"
                        className="form-control input-sm"
                        id="contact-email"
                        name="email"
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label
                      className="col-xs-4"
                      htmlFor="contact-phone"
                    >
                      Telefon:
                      <small>(optional)</small>
                    </label>
                    <div className="col-xs-8">
                      <input
                        value={this.formData.phone}
                        type="text"
                        className="form-control input-sm"
                        id="contact-phone"
                        name="phone"
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label
                      className="col-xs-4"
                      htmlFor="contact-message"
                    >
                      Nachricht:
                    </label>
                    <div className="col-xs-8">
                      <textarea
                        className="form-control"
                        id="contact-message"
                        name="message"
                        value={this.formData.message}
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <div className="col-xs-8 col-xs-offset-4">
                      <div className="checkbox">
                        <label
                          htmlFor="dsgvo-accepted"
                        >
                          <input
                            type="checkbox"
                            id="dsgvo-accepted"
                            name="dsgvoAccepted"
                            checked={this.formData.dsgvoAccepted}
                          />
                          <span>
                            Sie erklären sich damit einverstanden, dass Ihre Daten zur Bearbeitung
                            Ihres Anliegens verwendet werden. Weitere Informationen und Widerrufshinweise
                            finden Sie in der
                            {' '}
                            <Link to={getPath('fontend', 'dsgvo')}>Datenschutzerklärung</Link>
                            .
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="form-group">
                    <div className="col-xs-8 col-xs-offset-4">
                      <button
                        type="submit"
                        className="action btn btn-primary pull-right"
                        disabled={!complete}
                      >
                        Senden
                      </button>
                    </div>
                  </div>
                </div>
              )
              : null}

          </form>
        </div>
      </Content>
    )
    /* eslint-enable max-len */
  }
}



// WEBPACK FOOTER //
// ./src/frontend/base/components/ContactPage.js